module.exports = __webpack_public_path__ + "static/media/unavailable.c8841911.svg";